export default __webpack_public_path__ + "static/media/Versions - vs Official vs Films_03.76834e1d.jpg";